/* eslint-disable no-unused-vars */
import React from "react";
import { Box, useTheme } from "@mui/material";
import { FormattedMessage } from "react-intl";
import isEqual from "lodash/isEqual";
import { FacebookCircularProgress } from "../../common/components/Elements";
import IconDiamond from "../../../../public/assets/icons/IconDiamond";
import IconClock from "../../../../public/assets/icons/IconClock";
import IconQuestion from "../../../../public/assets/icons/IconQuestion";
import LockIcon from "../../../../public/assets/icons/LockIcon";
import IconUnlimited from "../../../../public/assets/icons/IconUnlimited";
import { TTheme } from "../../../utils/configs/setupTheme";

type TProps = {
  ele: any;
  isShowLock: (access_level) => boolean;
  onClickTopic: (ele) => void;
};

const SubjectCard = (props: TProps) => {
  const { ele, isShowLock, onClickTopic } = props;
  const theme: TTheme = useTheme();
  return (
    <Box
      className="flex flex-row items-start justify-between h-full cursor-pointer"
      style={{
        border: `1px solid ${theme.palette.primary.gray}`,
        borderRadius: 6,
        padding: 8,
        maxHeight: 120
      }}
      onClick={() => onClickTopic(ele)}
    >
      <div className="flex items-center flex-row justify-center mr-1 gap-2">
        <div className="flex flex-col justify-center items-center">
          {" "}
          <div className="mr-3 ml-2 relative inline-flex">
            <FacebookCircularProgress
              color={theme.palette.primary.main}
              size={48}
              variant="determinate"
              value={ele?.correct_rate}
            />
            <div
              style={{
                top: -6,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <span className="text-blackQuiz text-[13px] font-[500]">
                {`${Math.round(ele?.correct_rate ? ele?.correct_rate : 0)}`}
              </span>
            </div>
          </div>
          <div>
            {ele.num_of_times && (
              <Box
                style={{
                  color: theme.palette.primary.gray1,
                  width: 64,
                  height: 20,
                  fontSize: 12,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: -4
                }}
              >
                <FormattedMessage id="Times" values={{ num: ele.num_of_times }} />
              </Box>
            )}
          </div>
        </div>
        <div
          className="flex flex-col "
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden"
          }}
        >
          <span className="line-clamp-2 text-left my-[6px] text-[15px]">{ele.title}</span>
          <div className="flex w-full flex-row items-center text-gray400">
            <div className="flex items-center" style={{ fontSize: 12, marginRight: 16 }}>
              <IconDiamond width={12} height={12} className="svgFillAll" fill={theme.palette.primary.main} />
              &nbsp;
              {ele?.extra?.price}
            </div>
            <Box
              display="flex"
              alignItems="center"
              style={{
                fontSize: 12,
                marginRight: 16
                // width: 20,
                // height: 20,
              }}
            >
              <IconClock width={12} height={12} /> &nbsp;
              {ele?.extra?.time > -1 ? (
                <FormattedMessage id="num.minute" values={{ minute: ele?.extra?.time }} />
              ) : (
                <IconUnlimited />
              )}
            </Box>
            <Box
              display="flex"
              alignItems="center"
              style={{
                fontSize: 12,
                marginRight: 16
                // width: 20,
                // height: 20,
              }}
            >
              <IconQuestion width={12} height={12} />
              &nbsp; <FormattedMessage id="num.question" values={{ num: ele?.extra?.total }} />
            </Box>
          </div>
        </div>
      </div>
      <div className="mt-1.5">
        {!isShowLock(ele?.access_level) ? (
          <button type="button" className="w-4 h-4">
            <LockIcon />
          </button>
        ) : null}
      </div>
    </Box>
  );
};

const checkEqualProps = (prevProps, nextProps) => {
  return isEqual(prevProps?.ele, nextProps?.ele);
};

export default React.memo(SubjectCard, checkEqualProps);
